/**
 * @generated SignedSource<<d29eab24bd44364ca5a1daf09bd372f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLMessageMessageRole = "AGENT" | "HUMAN" | "%future added value";
export type SendMessageInput = {
  attachments?: ReadonlyArray<AttachmentInput> | null | undefined;
  context?: string | null | undefined;
  contextData?: string | null | undefined;
  jobRunId?: any | null | undefined;
  llmConversationId?: any | null | undefined;
  message: string;
};
export type AttachmentInput = {
  handle: string;
};
export type EmbeddedChatSendMessageMutation$variables = {
  input: SendMessageInput;
};
export type EmbeddedChatSendMessageMutation$data = {
  readonly sendMessage: {
    readonly llmConversation: {
      readonly createdAt: any;
      readonly id: any;
      readonly title: string;
      readonly updatedAt: any;
    };
    readonly userMessage: {
      readonly content: string;
      readonly createdAt: any;
      readonly id: string;
      readonly messageRole: GraphQLMessageMessageRole;
    };
  };
};
export type EmbeddedChatSendMessageMutation = {
  response: EmbeddedChatSendMessageMutation$data;
  variables: EmbeddedChatSendMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendMessagePayload",
    "kind": "LinkedField",
    "name": "sendMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLFormattedMessage",
        "kind": "LinkedField",
        "name": "userMessage",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "messageRole",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLLlmConversation",
        "kind": "LinkedField",
        "name": "llmConversation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmbeddedChatSendMessageMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmbeddedChatSendMessageMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "df9ecdfffef8c7aa4f70b07f5f4c0eb6",
    "id": null,
    "metadata": {},
    "name": "EmbeddedChatSendMessageMutation",
    "operationKind": "mutation",
    "text": "mutation EmbeddedChatSendMessageMutation(\n  $input: SendMessageInput!\n) {\n  sendMessage(input: $input) {\n    userMessage {\n      id\n      messageRole\n      content\n      createdAt\n    }\n    llmConversation {\n      id\n      title\n      createdAt\n      updatedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2687692b38f4ca8b782a571ba118967";

export default node;
